import { Modal } from "antd";
import { useTranslation } from "react-i18next";

/**
 * Returns a `confirmDelete` helper that shows a standardised Ant Design
 * confirmation dialog before calling the provided callback.
 *
 * Usage:
 *   const { confirmDelete } = useDeleteConfirm();
 *   <Button onClick={() => confirmDelete(handleDelete)}>Delete</Button>
 *
 * @returns {{ confirmDelete: (onOk: Function, titleKey?: string) => void }}
 */
const useDeleteConfirm = () => {
  const { t } = useTranslation();

  const confirmDelete = (onOk, titleKey = "delete_popup") => {
    Modal.confirm({
      title: t(titleKey),
      onOk: () => onOk?.(),
      onCancel() {},
      okText: t("okTitle"),
      cancelText: t("cancelTitle"),
    });
  };

  return { confirmDelete };
};

export default useDeleteConfirm;
